import { apiJson } from "../dependencies/api.ts";
import { useMessageHandler } from "../context/MessageContext.tsx";
import { PriceCalculationRequest } from "../models/priceCalculationRequest.ts";
import { PriceResponse } from "../models/priceResponse.ts";
import { useCallback } from "react";

export const useCalculatePrice = () => {
  const { handle } = useMessageHandler();

  const calculatePrice = useCallback(async (
    payload: PriceCalculationRequest
  ): Promise<PriceResponse | null> => {
    return await handle(async () => {
      const response = await apiJson.post("/price/calculate", payload);
      return response.data;
    }).catch(() => null);
  }, [handle]);

  return { calculatePrice };
};
